module.exports = __webpack_public_path__ + "img/login.4911662b.png";